// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--A9iq7";
export var launchPartner = "footer-module--launchPartner--xC+IH";